/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useContext, useState } from "react"
import BackButton from "../../../../components/Tablet/BackButton"
import { CSS_PROPERTY } from "../../cssProperties/tablet"
import { useHistory } from "react-router-dom"
import { TenkoKubunContext, TenkoDetailContext } from "../../context/context"
import ZyomuinInfo from "../../../../components/Tablet/ZyomuinInfo"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons"
import { T点呼区分, e点呼区分 } from "../../../../constant/enum/unko"
import {
  selectHiroSippeiSuiminBusokuPage,
  sonotaHokokuPage,
} from "../../../../constant/tablet/pages"
import { decimalPlus } from "../../../../ts/util/decimalUtil"

const InputAlcoholNumber = () => {
  const history = useHistory()
  const { 点呼区分 } = useContext(TenkoKubunContext)
  const { 点呼明細, set点呼明細 } = useContext(TenkoDetailContext)

  const [AL測定値, setAL測定値] = useState(0)

  const inputAL測定値 = useCallback(async () => {
    switch (点呼区分?.区分コード as T点呼区分) {
      case e点呼区分.始業点呼:
      case e点呼区分.始業点呼2:
      case e点呼区分.中間点呼１:
      case e点呼区分.中間点呼２:
      case e点呼区分.中間点呼３:
        set点呼明細({
          ...点呼明細,
          AL測定値,
        })

        history.push(selectHiroSippeiSuiminBusokuPage.Route.path)
        break
      //終業はその他報告事項を表示
      case e点呼区分.終業点呼:
      case e点呼区分.終業点呼2:
        set点呼明細({
          ...点呼明細,
          AL測定値,
        })

        history.push(sonotaHokokuPage.Route.path)
        break
      default:
        break
    }
  }, [AL測定値])

  const ALPointerDownEvent: (
    addNumber: number
  ) => React.PointerEventHandler<HTMLDivElement> =
    (addNumber: number) => (e) => {
      let AL測定値Inner = AL測定値
      const addAL測定値 = setInterval(() => {
        AL測定値Inner = decimalPlus([AL測定値Inner, addNumber])
        if (AL測定値Inner >= 0) {
          setAL測定値(AL測定値Inner)
        } else {
          setAL測定値(0)
        }
      }, 50)

      window.document.addEventListener(
        "pointerup",
        () => {
          clearInterval(addAL測定値)
        },
        { once: true }
      )
    }

  return (
    <>
      <ZyomuinInfo />
      <table
        style={{ tableLayout: "fixed", height: CSS_PROPERTY.BODY_TABLE_HEIGHT }}
        className="w-100 mt-3">
        <tbody>
          <tr>
            <td colSpan={2}>アルコール測定の結果の数値を入力してください。</td>
          </tr>
          <tr>
            <td
              colSpan={2}
              style={{
                fontSize: "5rem",
                height: "20rem",
              }}>
              <div
                className="text-end d-inline-block"
                style={{
                  width: "40rem",
                  backgroundColor: "white",
                  ...CSS_PROPERTY.BORER_PROPERTIES,
                }}>
                <span
                  className="mx-4"
                  style={{
                    color: AL測定値 >= 0.15 ? CSS_PROPERTY.WARN_COLOR : "",
                  }}>
                  {AL測定値.toFixed(2)}
                </span>
                <span className="me-4">ml</span>
              </div>
              <div
                className="d-inline-block text-center px-2"
                onContextMenu={() => false}
                onPointerDown={ALPointerDownEvent(-0.01)}
                style={{
                  ...CSS_PROPERTY.BORER_PROPERTIES,
                  width: "15rem",
                  color: "white",
                  backgroundColor: "#1eb684",
                  margin: "0 5rem 0 5rem",
                  touchAction: "none",
                  userSelect: "none",
                }}>
                <FontAwesomeIcon icon={faMinus} />
              </div>
              <div
                className="d-inline-block text-center px-2"
                onContextMenu={() => false}
                onPointerDown={ALPointerDownEvent(0.01)}
                style={{
                  ...CSS_PROPERTY.BORER_PROPERTIES,
                  width: "15rem",
                  color: "white",
                  backgroundColor: CSS_PROPERTY.WARN_COLOR,
                  touchAction: "none",
                  userSelect: "none",
                }}>
                <FontAwesomeIcon icon={faPlus} />
              </div>
            </td>
          </tr>
          <tr>
            <td
              className="align-bottom"
              style={{ height: CSS_PROPERTY.BODY_TABLE_BUTTON_ROW_HEIGHT }}>
              <BackButton />
            </td>
            <td className="text-end">
              <div
                className="d-inline-block"
                onTouchStart={inputAL測定値}
                style={{
                  bottom: "0",
                  backgroundColor: CSS_PROPERTY.WARN_COLOR,
                  color: "white",
                  width: "25rem",
                  textAlign: "center",
                  ...CSS_PROPERTY.BORER_PROPERTIES,
                  marginBottom: "1rem",
                  padding: "0.5rem 1rem",
                }}>
                <span>確定</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </>
  )
}

export default InputAlcoholNumber
